/* FW cart line-item property editor.
   snippets/line-item.liquid renders an Edit button, a hidden field list and
   Save/Cancel buttons for every line with visible properties — this wires them
   up. Uses delegated listeners so it survives the cart drawer's re-renders,
   and mirrors LineItemQuantity's cart/change.js contract (bundled sections +
   line-item:change / cart:change events) so the drawer refreshes itself. */
(function () {
  'use strict';

  function findByKey(selector, lineKey) {
    var match = null;
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.getAttribute('data-line-key') === lineKey) match = el;
    });
    return match;
  }

  function toggleEdit(lineKey, editing) {
    var display = findByKey('.line-item__properties-display', lineKey);
    var form = findByKey('.line-item__edit-form', lineKey);
    if (!display || !form) return;
    display.style.display = editing ? 'none' : '';
    form.style.display = editing ? 'block' : 'none';
    if (editing) {
      var first = form.querySelector('input');
      if (first) first.focus();
    }
  }

  async function saveProperties(button) {
    var lineKey = button.getAttribute('data-line-key');
    var quantity = parseInt(button.getAttribute('data-quantity'), 10) || 1;
    var form = findByKey('.line-item__edit-form', lineKey);
    if (!form) return;

    button.disabled = true;
    button.textContent = 'Saving…';

    try {
      // Merge edits over the line's existing properties so hidden (_-prefixed)
      // properties and file-upload URLs survive — cart/change.js replaces the
      // whole properties object.
      var cart = await (await fetch(Shopify.routes.root + 'cart.js')).json();
      var line = cart.items.find(function (item) { return item.key === lineKey; });
      if (!line) throw new Error('line not found');

      var properties = Object.assign({}, line.properties);
      form.querySelectorAll('input[name]').forEach(function (input) {
        properties[input.name] = input.value.trim();
      });

      var lineItem = form.closest('line-item');
      if (lineItem) {
        lineItem.dispatchEvent(new CustomEvent('line-item:will-change', {
          bubbles: true,
          detail: { targetQuantity: quantity }
        }));
      }

      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));

      var response = await fetch(Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity,
          properties: properties,
          sections: sectionsToBundle
        })
      });
      if (!response.ok) throw new Error('cart/change failed');
      var cartContent = await response.json();

      if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
        return;
      }

      if (lineItem) {
        lineItem.dispatchEvent(new CustomEvent('line-item:change', {
          bubbles: true,
          detail: { quantity: quantity, cart: cartContent }
        }));
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'line-item:change', cart: cartContent }
      }));
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Save';
      var errorTarget = form.closest('.line-item__info') || form;
      var existing = errorTarget.querySelector('[role="alert"]');
      if (existing) existing.remove();
      form.insertAdjacentHTML('beforeend',
        '<p class="text-error text-xs" role="alert">Could not save your changes. Please try again.</p>');
    }
  }

  document.addEventListener('click', function (event) {
    var editBtn = event.target.closest('.line-item__edit-btn');
    if (editBtn) {
      toggleEdit(editBtn.getAttribute('data-line-key'), true);
      return;
    }

    var cancelBtn = event.target.closest('.line-item__cancel-btn');
    if (cancelBtn) {
      toggleEdit(cancelBtn.getAttribute('data-line-key'), false);
      return;
    }

    var saveBtn = event.target.closest('.line-item__save-btn');
    if (saveBtn && !saveBtn.disabled) {
      saveProperties(saveBtn);
    }
  });
})();
